export default class CustomError extends Error {
    constructor(...params: Array<any>) {
        super(...params);

        this.name = this.constructor.name;

        if(Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        }
    }
}
